const env = process.env.NEXT_PUBLIC_ENV;

const hostHandler = (): string => {
  switch (env) {
    case 'local':
      return '';
    case 'development':
      return '';
    case 'production':
      return '';
  }
}

export const getAssetUrl = (url): string => hostHandler() ? `${url}${hostHandler()}` : url;